import React, { PropsWithChildren } from "react"

import { CustomerInfoProvider } from "../context"
import { CustomerInfo } from "../types/CustomerInfo"

export const StubCustomerInfoProvider = ({ children, mockCustomerInfo }: PropsWithChildren<{ mockCustomerInfo: CustomerInfo }>) =>
	<CustomerInfoProvider service={{ getCustomerInfo: async () => ({ data: mockCustomerInfo, status: 200, statusText: "OK" }) }}>
		{children}
	</CustomerInfoProvider>